module.exports = "/_next/static/images/futuresImage-e409122a5dce52c832bb0d0454a337f9.jpg.webp";